<div class="wrapper">
  <div class="header-section flex justify-start items-start gap-[32px]">
    @if (!isContractor) {
      <div
        (click)="selectSubTab('settings')"
        [class.selected]="activeSubTab === 'settings'"
        class="header text-type-3 cursor-pointer text-[#60698B]">
        Warranties
      </div>
    }
    @if (hasWarranties) {
      @if (!isContractor) {
        <div
          (click)="selectSubTab('tasks')"
          [class.selected]="activeSubTab === 'tasks'"
          class="header text-type-3 cursor-pointer text-[#60698B]">
          Tasks
        </div>
      }
      <div
        (click)="selectSubTab('claims')"
        [class.selected]="activeSubTab === 'claims'"
        class="header text-type-3 cursor-pointer text-[#60698B]">
        Claims
      </div>
      <div
        (click)="selectSubTab('packages')"
        [class.selected]="activeSubTab === 'packages'"
        class="header text-type-3 cursor-pointer text-[#60698B]">
        Packages
      </div>
    }
  </div>

  <div class="content-section">
    @switch (activeSubTab) {
      @case ('settings') {
        <app-warranty-settings />
      }
      @case ('tasks') {
        <app-warranty-tasks-list />
      }
      @case ('claims') {
        <app-warranty-claims-list />
      }
      @case ('packages') {
        <app-warranty-packages-list />
      }
    }
  </div>
</div>
